import React, {useEffect} from 'react';
import {Link} from "react-router-dom";

const Home = ({handleMenuClick}) => {
  useEffect(() => {
    window.scrollTo(0, 0); // scrolls to top when component mounts
  }, []);
  
  return (
    <>
    <main>
    <div id="main-image">  
      <img src="images/homepage/mobile/image-homepage-hero@2x.jpg"/>
    </div>
      
     <div id="intro-container">
     <article id="intro">
      <h2>
        Hey, I’m Fernando Lozano and I love building beautiful websites
      </h2> 
    </article>
    
    <div id="aboutme-btn">
      <a href="#aboutme-article">
        <button className="btn-pnormal">
          <div>
            <img src="images/icons/down-arrows.png"/>
          </div>
          
          <p>ABOUT ME</p>
        </button>
      </a>
    </div>
    </div>
    
    <section id="aboutme">
      <img src="images/homepage/mobile/20230213_123259.jpg"/>

      <article id="aboutme-article">
        <h2>        
          About Me
        </h2>
       
        <p className="body1 opacity80">
          I’m a junior front-end developer looking for a new role in an exciting company. 
          I focus on writing accessible HTML, using modern CSS practices and writing clean 
          JavaScript. When writing JavaScript code, I mostly use React, but I can adapt to 
          whatever tools are required. I’m based in Austin, TX, but I’m happy working remotely 
          and have experience in remote teams. When I’m not coding, you’ll find me outdoors. 
          I love being out in nature whether that’s going for a walk, run or cycling. I’d love 
          you to check out my work.
        </p>
        
        <Link to="/portfolio">
          <button id="portfolio" className="btn-snormal" onClick={handleMenuClick}>
            GO TO PORTFOLIO
          </button>
        </Link>
      </article>
    </section>
   </main>
    </>
  );
}

export default Home;